module.exports = __webpack_public_path__ + "img/se_text_logo.bb2ef85d.png";